<template>
  <va-form :id="id" :item="item" @input="isFormEdited = true">
    <v-row justify="center">
      <v-col lg="6">
        <base-material-card>
          <template #heading>
            <div class="display-2">
              {{ title }}
            </div>
          </template>
          <v-card-text>
            <v-row>
              <v-col>
                <va-text-input source="name" required></va-text-input>
                <va-autocomplete-input
                  source="realms"
                  label="Markets"
                  :chips="false"
                  :choices="availableMarket"
                  multiple
                  filled
                  required
                  item-text="realm"
                  item-value="code"
                >
                </va-autocomplete-input>
              </v-col>

              <v-col>
                <template v-if="item && !isCloneMode">
                  <v-text-field
                    label="Created at"
                    regular
                    readonly
                    :value="new Date(item.createdAt).toLocaleDateString('en-CA')"
                  ></v-text-field>
                  <v-text-field
                    label="Last updated at"
                    regular
                    readonly
                    :value="new Date(item.lastUpdatedAt).toLocaleDateString('en-CA')"
                  ></v-text-field>
                </template>
              </v-col>
            </v-row>
            <va-save-button label="Save"></va-save-button>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>
  </va-form>
</template>

<script>
import { defaultRealms } from '@/foundations/helpers/defaultRealms';

export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      availableMarket: defaultRealms,
    };
  },
  computed: {
    isCloneMode() {
      const urlParams = new URLSearchParams(window.location.search);
      return !!urlParams.get('source');
    },
  },
};
</script>
